import {
  Box,
  Typography,
  Tooltip,
} from '@mui/material';
import { T, Icon, stitchPill, stitchOutlineBtn, stitchCard, stitchTooltipSlotProps } from './stitch';
import { statusColors, typeColors, formatFormaat, formatDate } from './projectMeta';


// Deliverable Card
function DeliverableCard({ item, onGenerateTasks, onClick, taskCount = 0 }) {
  const name = item.fields?.['Naam van Deliverable'] || item.fields?.Deliverable || 'Deliverable';
  const deadline = formatDate(item.fields?.Deadline);
  const status = item.fields?.Status || 'Nog niet gestart';
  const format = formatFormaat(item.fields?.Formaat);
  const length = item.fields?.LengteVideo ? `${item.fields.LengteVideo}s` : '';
  const needsSubtitles = item.fields?.['Ondertitel nodig'];
  const needsThumbnail = item.fields?.['Thumbnail Nodig?'];

  const statusStyle = statusColors[status] || statusColors['Nog niet gestart'];
  const accent = typeColors[item.fields?.Type] || T.tertiary;

  return (
    <Box
      onClick={onClick}
      sx={{
        p: 2.5,
        ...stitchCard,
        borderLeft: `4px solid ${accent}`,
        cursor: 'pointer',
        '&:hover': {
          boxShadow: '0 8px 24px rgba(45,51,53,0.08)',
          transform: 'translateY(-2px)',
        },
      }}
    >
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', mb: 2 }}>
        <Box sx={{ flex: 1, pr: 2 }}>
          <Typography variant="subtitle2" sx={{ fontFamily: T.font, fontWeight: 600 }}>
            {name}
          </Typography>
          {taskCount > 0 && (
            <Typography variant="caption" sx={{ fontFamily: T.fontBody, color: T.outline }}>
              {taskCount} taken gekoppeld
            </Typography>
          )}
        </Box>
        <Typography component="span" sx={stitchPill(statusStyle.text, statusStyle.bg)}>
          {status}
        </Typography>
      </Box>

      <Box sx={{ display: 'flex', gap: 2, flexWrap: 'wrap', mb: 2 }}>
        {deadline && (
          <Typography variant="caption" sx={{ fontFamily: T.fontBody, color: T.outline, display: 'flex', alignItems: 'center', gap: 0.5 }}>
            <Icon name="calendar_today" size={12} />
            {deadline}
          </Typography>
        )}
        {format && (
          <Typography variant="caption" sx={{ fontFamily: T.fontBody, color: T.outline, display: 'flex', alignItems: 'center', gap: 0.5 }}>
            <Icon name="aspect_ratio" size={13} sx={{ color: accent }} /> {format}
          </Typography>
        )}
        {length && (
          <Typography variant="caption" sx={{ fontFamily: T.fontBody, color: T.outline, display: 'flex', alignItems: 'center', gap: 0.5 }}>
            <Icon name="timer" size={13} sx={{ color: accent }} /> {length}
          </Typography>
        )}
        {needsSubtitles && (
          <Tooltip title="Ondertiteling nodig" slotProps={stitchTooltipSlotProps}>
            <Typography component="span" sx={{ display: 'inline-flex', alignItems: 'center', gap: 0.4,
              px: 0.9, py: 0.2, borderRadius: '9999px', bgcolor: '#dbeafe', color: '#1d4ed8',
              fontFamily: T.fontBody, fontSize: 10.5, fontWeight: 700 }}>
              <Icon name="subtitles" size={12} /> ondertitels
            </Typography>
          </Tooltip>
        )}
        {needsThumbnail && (
          <Tooltip title="Thumbnail nodig" slotProps={stitchTooltipSlotProps}>
            <Typography component="span" sx={{ display: 'inline-flex', alignItems: 'center', gap: 0.4,
              px: 0.9, py: 0.2, borderRadius: '9999px', bgcolor: '#fce7f3', color: '#be185d',
              fontFamily: T.fontBody, fontSize: 10.5, fontWeight: 700 }}>
              <Icon name="image" size={12} /> thumbnail
            </Typography>
          </Tooltip>
        )}
      </Box>

      {/* Generate Tasks Button */}
      <Tooltip title="Genereer postproductie taken uit een template" slotProps={stitchTooltipSlotProps}>
        <Box
          component="span"
          onClick={(e) => {
            e.stopPropagation();
            onGenerateTasks?.(item);
          }}
          sx={stitchOutlineBtn}
        >
          <Icon name="auto_awesome" size={16} />
          Planning genereren
        </Box>
      </Tooltip>
    </Box>
  );
}

export default DeliverableCard;
